import { C } from "../lib/theme";
import { Eyebrow } from "./Eyebrow";
import { Icon } from "./Icon";

export function SectionHeader({ eyebrow, title, count, onSeeAll }) {
  return (
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
      <div>
        <Eyebrow>{eyebrow}</Eyebrow>
        <h2 style={{ fontSize: 22, fontWeight: 900, margin: "2px 0 0", letterSpacing: "-0.5px" }}>
          {title}
        </h2>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        {typeof count === "number" && (
          <span style={{ fontSize: 12, color: C.muted, fontWeight: 600 }}>{count} items</span>
        )}
        {onSeeAll && (
          <button onClick={onSeeAll} style={{
            border: "none", background: "transparent", color: C.hunter,
            fontSize: 12.5, fontWeight: 800, cursor: "pointer",
            display: "inline-flex", alignItems: "center", gap: 4, fontFamily: "inherit",
          }}>
            See all <Icon name="arrow-right" size={13} color={C.hunter} />
          </button>
        )}
      </div>
    </div>
  );
}
